export default __webpack_public_path__ + "static/media/trickKeto.e6167f79.svg";